import { useEffect, useState } from "react";
import axios from "axios";
import { Layout } from "../components/layout";
import { HeroSection, ServicesSection, RecentBlogsSection, CTASection } from "../components/sections";
import { SEO } from "../components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomePage = () => {
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [blogsRes, navRes] = await Promise.all([
          axios.get(`${API}/blogs/recent?limit=2`),
          axios.get(`${API}/navigation`),
        ]);
        setRecentBlogs(blogsRes.data);
        setNavItems(navRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <Layout navItems={navItems}>
      <SEO
        title="Web Development for Small Business & Non-Profits"
        description="It's IT specializes in professional websites and content management systems for small businesses and non-profits. Vibe Coding – Smarter, Faster Web Solutions."
        keywords="web development, small business website, non-profit website, CMS, content management system, Arizona web design"
      />
      <HeroSection />
      <ServicesSection location="homepage" />
      <RecentBlogsSection blogs={recentBlogs} />
      <CTASection />
    </Layout>
  );
};

export default HomePage;
